import { API_URL, getAuthHeaders } from './config';

export const pushService = {
    subscribe: async (subscription: any) => {
        const res = await fetch(`${API_URL}/push/subscribe`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(subscription)
        });
        if (!res.ok) throw new Error("Failed to subscribe");
        return res.json();
    },
    unsubscribe: async (endpoint: string) => {
        const res = await fetch(`${API_URL}/push/unsubscribe`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ endpoint })
        });
        if (!res.ok) throw new Error("Failed to unsubscribe");
        return res.json();
    },
    sendTest: async (targetUserId?: string) => {
        const res = await fetch(`${API_URL}/push/test`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ targetUserId })
        });
        if (!res.ok) {
            const err = await res.json().catch(() => ({ error: "Failed to send test" }));
            throw new Error(err.error || "Failed to send test");
        }
        return res.json();
    }
};
